(function(){
  'use strict';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  function icon(name){
    var icons={
      link:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.1 1.1"></path><path d="M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.1-1.1"></path></svg>',
      instagram:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r=".8" fill="currentColor" stroke="none"></circle></svg>',
      whatsapp:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 11.6a8.5 8.5 0 0 1-12.6 7.4L3 20.5l1.6-4.7a8.5 8.5 0 1 1 15.9-4.2Z"></path><path d="M8.4 7.8c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.5l.7 1.7c.1.3.1.5-.1.7l-.6.8c-.2.2-.1.4 0 .6.6 1.1 1.5 2 2.6 2.6.2.1.4.2.6 0l.9-1c.2-.2.4-.2.7-.1l1.7.8c.3.1.5.3.5.5 0 .3-.1 1.4-.8 2-.6.6-1.5.9-2.4.7-1.1-.2-2.6-.7-4.4-2.3-1.5-1.3-2.5-2.9-2.8-4-.3-1-.1-2 .4-2.7Z"></path></svg>',
      facebook:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.5 21v-8h3l.5-3h-3.5V8c0-1.6.8-2.5 2.6-2.5H17V3h-3.4C10.6 3 9 4.8 9 7.7V10H6v3h3v8"></path></svg>'
    };
    return icons[name] || '';
  }

  function shareData(){
    var titleNode=document.querySelector('.pdp-title');
    return {
      title:titleNode ? titleNode.textContent.trim() : document.title,
      url:window.location.href
    };
  }

  function track(channel){
    if(Array.isArray(window.dataLayer)){
      window.dataLayer.push({event:'share_tour_click',share_channel:channel,page_location:window.location.href});
    }
  }

  function copyLink(url){
    if(navigator.clipboard && navigator.clipboard.writeText){
      return navigator.clipboard.writeText(url);
    }
    return new Promise(function(resolve,reject){
      try{
        var input=document.createElement('textarea');
        input.value=url;
        input.setAttribute('readonly','');
        input.style.position='fixed';
        input.style.opacity='0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
        resolve();
      }catch(err){ reject(err); }
    });
  }

  var toastTimer;
  function toast(message){
    var node=document.getElementById('pmy-share-rail-toast');
    if(!node){
      node=document.createElement('div');
      node.id='pmy-share-rail-toast';
      node.className='pmy-share-rail-toast';
      document.body.appendChild(node);
    }
    node.textContent=message;
    node.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer=window.setTimeout(function(){ node.classList.remove('is-visible'); },1800);
  }

  async function act(action){
    var data=shareData();
    track(action);
    try{
      if(action==='link'){
        await copyLink(data.url);
        toast('Link copied');
        return;
      }
      if(action==='whatsapp'){
        window.open('https://wa.me/?text='+encodeURIComponent(data.title+' '+data.url),'_blank','noopener');
        return;
      }
      if(action==='facebook'){
        window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(data.url),'_blank','noopener,width=720,height=560');
        return;
      }
      if(action==='instagram'){
        if(navigator.share && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)){
          await navigator.share({title:data.title,text:data.title,url:data.url});
        }else{
          await copyLink(data.url);
          toast('Link copied for Instagram');
          window.open('https://www.instagram.com/','_blank','noopener');
        }
      }
    }catch(err){

    }
  }

  var actionItems=[
    ['link','Copy link'],
    ['instagram','Instagram'],
    ['whatsapp','WhatsApp'],
    ['facebook','Facebook']
  ];

  function addActions(container){
    actionItems.forEach(function(item){
      var button=document.createElement('button');
      button.type='button';
      button.className='pmy-product-share-action';
      button.setAttribute('aria-label',item[1]);
      button.setAttribute('title',item[1]);
      button.dataset.shareRail=item[0];
      button.innerHTML=icon(item[0]);
      button.addEventListener('click',function(){ act(item[0]); });
      container.appendChild(button);
    });
  }

  function createRail(){
    if(document.getElementById('pmy-product-share-rail')) return;
    if(!document.querySelector('.pdp-container')) return;

    var rail=document.createElement('nav');
    rail.id='pmy-product-share-rail';
    rail.className='pmy-product-share-rail';
    rail.setAttribute('aria-label','Share this tour');
    addActions(rail);
    document.body.appendChild(rail);
  }

  function createInlineShare(){
    if(document.getElementById('pmy-product-share-inline')) return;
    var title=document.querySelector('.pdp-title');
    if(!title) return;

    var inline=document.createElement('nav');
    inline.id='pmy-product-share-inline';
    inline.className='pmy-share-inline';
    inline.setAttribute('aria-label','Share this tour');

    var label=document.createElement('span');
    label.className='pmy-share-inline-label';
    label.textContent='Share';
    inline.appendChild(label);
    addActions(inline);

    title.insertAdjacentElement('afterend',inline);
  }

  var boundaryRaf=0;
  function updateRailBoundary(){
    boundaryRaf=0;
    var rail=document.getElementById('pmy-product-share-rail');
    var main=document.querySelector('.pmy-pdp-conversion-main');
    if(!rail || !main || window.innerWidth<1200) return;

    rail.style.setProperty('--pmy-share-rail-shift','0px');
    var railRect=rail.getBoundingClientRect();
    var mainRect=main.getBoundingClientRect();
    var safety=26;
    var overlap=(railRect.bottom+safety)-mainRect.bottom;
    var shift=overlap>0 ? -overlap : 0;
    rail.style.setProperty('--pmy-share-rail-shift',shift+'px');
  }

  function scheduleBoundaryUpdate(){
    if(boundaryRaf) return;
    boundaryRaf=window.requestAnimationFrame(updateRailBoundary);
  }

  function createShareUi(){
    if(!document.querySelector('.pdp-container')) return;
    document.body.classList.add('template-product');
    createRail();
    createInlineShare();
    scheduleBoundaryUpdate();
  }

  ready(function(){
    createShareUi();
    window.addEventListener('scroll',scheduleBoundaryUpdate,{passive:true});
    window.addEventListener('resize',scheduleBoundaryUpdate,{passive:true});
  });

  document.addEventListener('shopify:section:load',function(){
    window.setTimeout(createShareUi,0);
  });
})();
